export const environment = {
  production: true,
  API_URL: "https://api.prod.geofret.bility.fr"
};



// WEBPACK FOOTER //
// /usr/src/app/src/environments/environment.ts